import QRCode from 'qrcode';

import { useCallback } from 'react';

import AppLogger from 'utils/AppLogger';

const useQrCode = () => {
	const generateQrCode = useCallback(async (text, width) => {
		try {
			if (!text) {
				throw new Error('No text to generate QR code');
			}
			const qrOption = {
				width,
				color: { dark: '#000000', light: '#ffffff' }
			};
			const qrCode = await QRCode.toDataURL(text, qrOption);

			return qrCode;
		} catch (error) {
			AppLogger.error('Failed to generate QR code', error);
			return null;
		}
	}, []);

	return { generateQrCode };
};

export default useQrCode;
